(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
window.SectionFooter = (function(){
  function SectionFooter() {
    this._run();
  }

  SectionFooter.prototype = {
    _run: function() {

      if ( window.innerWidth < 768 )
        $('.site-footer .menu-footer-grid').addClass('clickable');
      else
		    $('.site-footer .menu-footer-grid').removeClass('clickable');

		$(window).resize(function(){
      if ( window.innerWidth < 768 ) {
        $('.site-footer .menu-footer-grid').addClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').hide();
      } else {
        $('.site-footer .menu-footer-grid').removeClass('clickable');
        $('.site-footer .menu-footer-grid .no-bullets').show();
		  }
		});

		$('.site-footer .menu-footer-grid').click(function(){
		  	if (window.innerWidth < 768 && $(this).hasClass('clickable')) {

          $('.site-footer .menu-footer-grid .no-bullets').stop().slideUp();

          if ($('.no-bullets', this).is(':visible')){
            $('.no-bullets', this).stop().slideUp();
            $('.nav-title', this).removeClass('row-rotate');
          }else {
            $('.nav-title', this).addClass('row-rotate');
            $('.no-bullets', this).stop().slideDown();
            $(this).siblings().children('.nav-title').removeClass('row-rotate');
        }
      }
      });
    },

    onLoad: function() {
      this._run();
    },

    onUnload: function() {

    }
  };

  return new SectionFooter;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-mobile"]) return;
  try {
    
// Solução imediata - executa instantaneamente

// Função para resetar o estado do menu mobile
function resetMobileMenuState() {
  document.body.classList.remove('js-drawer-open-left', 'cart-open', 'cart-drawer-open');
  
  const mainContent = document.querySelector('.main-content');
  const fixedElements = document.querySelectorAll('.fixed');
  const header = document.querySelector('.shopify-section header');
  const search = document.querySelector('.search');
  
  if (mainContent) mainContent.classList.remove('is-moved-by-drawer');
  fixedElements.forEach(el => el.classList.remove('is-moved-by-drawer'));
  if (header) header.classList.remove('is-moved-by-drawer');
  if (search) search.classList.remove('is-moved-by-drawer');
  
}

// Função para abrir o menu mobile
function openMobileMenu() {
  
  const mainContent = document.querySelector('.main-content');
  const fixedElements = document.querySelectorAll('.fixed');
  const header = document.querySelector('.shopify-section header');
  const search = document.querySelector('.search');
  
  if (mainContent) mainContent.classList.add('is-moved-by-drawer');
  fixedElements.forEach(el => el.classList.add('is-moved-by-drawer'));
  if (header) header.classList.add('is-moved-by-drawer');
  if (search) search.classList.add('is-moved-by-drawer');
  document.body.classList.add('js-drawer-open-left');
  
}

// Função para fechar o menu mobile
function closeMobileMenu() {
  
  const mainContent = document.querySelector('.main-content');
  const fixedElements = document.querySelectorAll('.fixed');
  const header = document.querySelector('.shopify-section header');
  const search = document.querySelector('.search');
  
  document.body.classList.remove('js-drawer-open-left');
  if (mainContent) mainContent.classList.remove('is-moved-by-drawer');
  fixedElements.forEach(el => el.classList.remove('is-moved-by-drawer'));
  if (header) header.classList.remove('is-moved-by-drawer');
  if (search) search.classList.remove('is-moved-by-drawer');
  
}

// Função para toggle do menu
function toggleMobileMenu() {
  if (document.body.classList.contains('js-drawer-open-left')) {
    closeMobileMenu();
  } else {
    openMobileMenu();
  }
}

// Função para configurar event listeners
function setupEventListeners() {
  
  const openButton = document.getElementById('IconMenuTextMobile');
  const closeButton = document.getElementById('id-icon-fallback-text');
  const overlay = document.querySelector('.DrawerOverlay');
  
  if (openButton) {
    
    // Remove event listeners existentes
    const newOpenButton = openButton.cloneNode(true);
    openButton.parentNode.replaceChild(newOpenButton, openButton);
    
    newOpenButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileMenu();
    });
    
  } else {
  }
  
  if (closeButton) {
    
    // Remove event listeners existentes
    const newCloseButton = closeButton.cloneNode(true);
    closeButton.parentNode.replaceChild(newCloseButton, closeButton);
    
    newCloseButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileMenu();
    });
    
  } else {
  }
  
  if (overlay) {
    overlay.addEventListener('click', function() {
      document.body.classList.remove('js-drawer-open-left', 'cart-open', 'cart-drawer-open');
    });
    
  }
}

// Executa imediatamente
resetMobileMenuState();

// Aguarda um pouco para garantir que os elementos existam
setTimeout(function() {
  setupEventListeners();
}, 100);

// Também executa quando DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setupEventListeners();
  });
}

// Reset do menu quando a página carrega completamente
window.addEventListener('load', function() {
  resetMobileMenuState();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
window.SectionReviews = (function(){
  function SectionReviews() {
    this.settings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1019,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionReviews.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed,
          settings = this.settings;

      jQuery('[id^="slider-reviews-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionReviews;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping_bar"]) return;
  try {
    
  window.SectionShippingBar = (function () {
    function SectionShippingBar() {
      this._run();
    }

    SectionShippingBar.prototype = {
      _run: function () {
        update_shipping_bar(VastaShop.Cart.current);
      },
      onSelect: function () {
        this._run();
      },
      onBlockSelect: function () {
        this._run();
      },
    };

    return new SectionShippingBar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-promotional"] && !Shopify.designMode) return;
  try {
    
window.SectionSliderPromotional = (function(){
  function SectionSliderPromotional() {
    this.settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
              breakpoint: 1180,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 1019,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionSliderPromotional.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed, settings = this.settings;

      jQuery('[id^="slider-promotional-"]').each(function(){
        slider = '#promotional-' + $(this).data('slider');

        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionSliderPromotional;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    

window.SectionVideoSlider = (function(){
    function SectionVideoSlider() {
      this._run();
    }

    SectionVideoSlider.prototype = {
      onSelect: function() {
        this._run();
      },

      _run: function() {
        $('.dynamic-video__slider-container').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
          nextArrow: '<button type="button" class="slick-next">&rang;</button>',
          infinite: true
        });
      }
    };

    return new SectionVideoSlider;
})();


  } catch(e) { console.error(e); }
})();
})();
